import { closePopup, openPopup } from '@/popups/popup';
import $ from 'jquery';

export function popupAccessInit() {
  //todo заменить на нужное условие. Проверка на то что бы показывать начальный попап или нет.
  if (window.localStorage.getItem('access-popup') !== 'yes') {
    openPopup($('#popup-access'));
  }

  $('.popup-access-accept').on('click', () => {
    /*todo действия при подтверждении*/
    window.localStorage.setItem('access-popup', 'yes'); //todo заменить на нужное действие
    closePopup($('#popup-access'));
  });

  $('.popup-access-dismiss').on('click', () => {
    /*todo действия при отклонении*/

    window.close();
  });
}
